module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/promise-icon/promise-icon.component.scss
// module id = ./src/app/modules/base-module/components/promise-icon/promise-icon.component.scss
// module chunks = 9